import { render, staticRenderFns } from "./ActionColMenuItem.vue?vue&type=template&id=e0df162e"
import script from "./ActionColMenuItem.vue?vue&type=script&lang=js"
export * from "./ActionColMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports